import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOndernemerToevoegen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFEFE9"
      fillRule="evenodd"
      d="M6 33h21V10h-6V4H6v29"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m21 4 3 3 3 3h-6z"
      clipRule="evenodd"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      d="M8 12h11M8 15h9M8 18h10"
    />
    <path
      fill="#FF7842"
      d="M30 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M30 20c3.31 0 6 2.69 6 6v10H24V26c0-3.31 2.69-6 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m30 21.76-2 8 2 2 2-2z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M16 28h-4v-4H8v4H4v4h4v4h4v-4h4z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOndernemerToevoegen);

export default ForwardRef;
